import React from 'react';
import { Container, Row, Col, Card } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';


const ContactInfo = () => {
  const { t } = useTranslation();
  
  return (
    <Container className="my-5">
      <Row className="justify-content-center">
        <Col md={8}>
          <Card className="shadow-sm border-0">
            <Card.Body className="text-center">
              <h2 className="mb-4">📬 {t('text.title.anyQuestion')}</h2>
              <p className="lead">
                {t('text.title.anyQuestionDetailed')}
              </p>
              <p className="lead">
                {t('text.title.anyQuestionStatement')}
              </p>
              <a href="mailto:mandza.eu@gmail.com" className="btn btn-outline-primary btn-lg mt-3">
                📧 {t('sendEmailToUs')}
              </a>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default ContactInfo;
